import history from '../../../../../history'
import { useIntl, defineMessages } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Icon, Button } from '@homebotapp/hb-react-component-catalog'
import { selectClientIsGuest } from '../../../../../store/selectors/client'
import { toggleAuthModal } from '../../../../../actions/homeSearchAuthModal'
import { setScheduleTourShowModal } from '../../../../../store/slices/scheduleTour'

export const MSG = defineMessages({
  tour: {
    id: 'ScheduleTourButton.shortCta',
    defaultMessage: 'Tour'
  },
  schedule: {
    id: 'ScheduleTourButton.longCta',
    defaultMessage: 'Schedule a tour'
  }
})

export const ScheduleTourButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isGuest = useSelector(selectClientIsGuest)

  const handleTour = () => {
    if (isGuest) {
      history.push(`?redirectUrl=${window.location.href}`)
      dispatch(toggleAuthModal(true))
    } else {
      dispatch(setScheduleTourShowModal(true))
    }
  }

  return (
    <Button
      size='sm'
      colorScheme='secondary'
      onClick={handleTour}
      leftIcon={<Icon name='home' />}
      title={intl.formatMessage(MSG.schedule)}
    >
      {intl.formatMessage(MSG.tour)}
    </Button>
  )
}
